import { pushRoute } from "../common/route"
import { setterAction } from "../common/redux"
import Source from "./Source"
import * as t from "./actionTypes"
import { _setProfiles } from "../account/actions"
import urls from "../common/urls"
import { unmountBeforeUnload } from "../common/common"
import { PAY_LINKS } from "./constants"
import { loginSuccess } from "../auth/actions"
import tracker from "../common/tracker"
import { captureException } from "../common/error"
import { setShowTipModal } from "../completion/actions"
import { teleMedicineAccountState, initialAccountState } from "../account/components/UserDetailsFormConfig";

export const setPaid = setterAction(t.SET_PAID)
export const setSaved = setterAction(t.SET_SAVED)
export const setIntegration = setterAction(t.SET_INTEGRATION)
export const setReEntry = setterAction(t.SET_REENTRY)
export const setTimedOut = setterAction(t.SET_TIMED_OUT)
export const setTipped = setterAction(t.SET_TIPPED)
export const setDisableTipping = setterAction(t.SET_DISABLE_TIP)
export const setTipErrorMsg = setterAction(t.SET_TIP_ERROR_MSG)
export const setPaymentErrorMsg = setterAction(t.SET_PAYMENT_ERROR_MSG)
export const showTelemedicineModal = setterAction(t.SHOW_TELEMEDICINE_MODAL)

// TODO: Rename this entire module as telemedicine and account forms 
// have a ton of overlap but one does not result in payment.

const TIMEOUT = 5 * 60 * 1000

export const getUserCharges = () => dispatch => {
  Source.getUserCharges()
    .then(data => {
      dispatch(setReEntry(data))
    })
    .catch(captureException)
}

export const initPayment = (recommendation, diffToken) => (
  dispatch,
  getState
) => {
  const { reEntry } = getState().payment
  const isReEntry = Object.entries(reEntry).some(i => i[1])

  if (isReEntry) return dispatch(samlHandoff(true))

  dispatch(startTimedOutCheck())
  dispatch(setIntegration(recommendation))

  // Tracking for GA and backend
  tracker.recommendationUserAction(recommendation.name, recommendation.token)

  // dispatch(connect(recommendation, diffToken))

  Source.getSavedPaymentInfo()
    .then(data => {
      dispatch(setSaved(data))
      dispatch(routeToAccountOrPayment())
    })
    .catch(() => {
      dispatch(routeToAccountOrPayment())
    })
}

export const startTimedOutCheck = () => (dispatch, getState) => {
  const { completion, auth } = getState()
  const { completedTime } = completion
  const { isAnonymous } = auth

  if (isAnonymous) {
    const currentTime = new Date()
    const remaining =
      TIMEOUT - (currentTime.getTime() - completedTime.getTime())

    setTimeout(() => {
      dispatch(checkIfTimedOut())
    }, remaining)
  }
}

export const checkIfTimedOut = () => (dispatch, getState) => {
  const { completion, auth } = getState()
  const { isAnonymous, status } = auth
  const { completed } = completion

  if ((isAnonymous || !status.login.transferred) && completed) {
    dispatch(setTimedOut(true))
  }
}

export const routeToAccountOrPayment = () => (dispatch, getState) => {
  const { account } = getState()
  const { profiles } = account
  const profile = profiles.find(p => p.isself)

  const complete =
    profile &&
    Object.keys(transformFields(initialAccountState))
      .filter(
        field => !["email", "password", "passwordConfirm"].contains(field)
      )
      .every(key => profile.hasOwnProperty(key) && profile[key])

  if (complete) {
    pushRoute("/pay/payment", true)
  } else {
    pushRoute("/pay/account", true)
  }
}

export const makePayment = stripe => (dispatch, getState) => {
  const { payment, account } = getState()
  const { saved, paid, integration } = payment
  const { profiles } = account
  const recommendation = integration

  if (paid) return

  if (saved) {
    dispatch(chargeUser(recommendation))
  } else {
    const profile = profiles.find(p => p.isself)
    const name = profile.first_name + profile.last_name

    stripe.createToken({ name }).then(({ token, error }) => {
      if (error) {
        dispatch(setPaymentErrorMsg(error.message))
        dispatch(setPaid(false))
      } else {
        dispatch(chargeUser(recommendation, token))
      }
    })
  }
}

export const makeButtonPayment = token => (dispatch, getState) => {
  const { payment } = getState()
  const { paid, integration } = payment
  const recommendation = integration

  if (paid) return

  return dispatch(chargeUser(recommendation, token, true))
}

export const chargeUser = (
  recommendation,
  token,
  noSave = false
) => dispatch => {
  return Source.chargeUser(
    recommendation.resource_token,
    token ? token.id : null,
    noSave
  )
    .then(() => {
      dispatch(setPaid(true))
      pushRoute("/pay/submit/", true)
    })
    .catch(err => {
      dispatch(setPaid(false))
      dispatch(setPaymentErrorMsg(err.response.data))
    })
}

const transformFields = fields => {
  // TODO: Refactor
  const orderedFields = {}
  Object.keys(fields).forEach(f => (orderedFields[f] = fields[f].value))
  orderedFields["first_name"] = orderedFields["first"]
  orderedFields["last_name"] = orderedFields["last"]
  delete orderedFields["first"]
  delete orderedFields["last"]
  return orderedFields
}

export const submitAccountInfoAndRedirectToPayment = fields => dispatch => {
  dispatch(submitAccountInfo(fields)).then(() =>
    pushRoute(`${PAY_LINKS.payment}`, true)
  )
}

export const submitAccountInfo = fields => (dispatch, getState) => {
  const { auth, account } = getState()
  const loggedIn = !auth.isAnonymous
  const orderedFields = transformFields(fields)
  const self = account.profiles.find(p => p.isself)

  if (loggedIn && self) {
    return Source.updateProfile(self.id, orderedFields).then(data => {
      dispatch(_setProfiles([data]))
      return data
    })
  } else if (loggedIn) {
    return Source.createProfile({ ...orderedFields, isself: true }).then(data => {
      dispatch(_setProfiles([data]))
      return data
    })
  } else {
    return Source.signupWithPassword(fields.email.value, fields.password.value)
      .then(data => {
        dispatch(loginSuccess(data))
        dispatch(checkIfTimedOut())
        if (self) {
          return Source.updateProfile(self.id, orderedFields)
        } else {
          return Source.createProfile({ ...orderedFields, isself: true })
        }
      })
      .then(data => {
        dispatch(_setProfiles([data]))
        return data
      })
  }
}

export const samlHandoff = reEntry => (dispatch, getState) => {
  unmountBeforeUnload()
  // CirrusMD is hardcoded for now, until we find a way to get
  // the integration info for re-entry
  window.location = `${urls.samlResponse}?sp=cirrusmd${
    reEntry ? `&reentry=true` : ""
  }`
}

export const chargeUserTip = (token, tip) => dispatch => {
  return Source.chargeUser(null, token ? token.id : null, true, tip)
    .then(() => {
      dispatch(setTipped(true))
      setTimeout(() => {
        dispatch(setShowTipModal(false))
      }, 3000)

      tracker.tipSuccessful(tip)
    })
    .catch(err => {
      let errMsg = err.response.data
      dispatch(setTipped(false))
      dispatch(setDisableTipping(false))
      dispatch(setTipErrorMsg(errMsg))

      tracker.tipError(errMsg)
    })
}

export const collectTip = (stripe, amount) => (dispatch, getState) => {
  dispatch(setTipErrorMsg(""))
  dispatch(setDisableTipping(true))
  stripe.createToken({ type: "card" }).then(({ token, error }) => {
    if (error) {
      dispatch(setTipErrorMsg(error.message))
      dispatch(setDisableTipping(false))
      tracker.tipError(error.message)
    } else dispatch(chargeUserTip(token, amount))
  })
}

export const collectApplePayTip = (token, amount) => (dispatch, getState) => {
  dispatch(setTipErrorMsg(""))
  dispatch(setDisableTipping(true))
  dispatch(chargeUserTip(token, amount))
}

export const initIntellivisit = () => (dispatch, getState) => {
  const { account } = getState()
  const { profiles } = account
  const profile = profiles.find(p => p.isself)

  const complete =
    profile &&
    Object.keys(transformFields(teleMedicineAccountState))
      .filter(
        field => !["email", "password", "passwordConfirm"].contains(field)
      )
      .every(key => profile.hasOwnProperty(key) && profile[key])

  if (complete) {
    dispatch(showTelemedicineModal(true))
  } else {
    pushRoute("/telemedicine/", true)
  }
}

export const cancelIntellivisit = () => (dispatch) => {
  dispatch(showTelemedicineModal(false))
  pushRoute("/symptom-checker/")
}

export const submitAccountInfoAndShowModal = fields => (dispatch, getState) => {
  dispatch(submitAccountInfo(fields)).then(() =>
    dispatch(showTelemedicineModal(true))
  )
}

export const sendVisitData = () => (dispatch, getState) => {
  const { brand } = getState()

  Source.sendVisit(brand.name).then(data => {
    pushRoute(data.redirect_url)
  })
}


// WEBPACK FOOTER //
// ./assets/payment/actions.js